<script setup>
import {computed} from 'vue'
import Button from "@/common/Button.vue"
import {useThemesStore} from '@/stores/themes'

const themesStore = useThemesStore()

// --- Computed ---

const sortAlpha = computed(() => themesStore.sortAlpha)

// --- Methods ---

const toggleSortAlpha = () => {
    themesStore.toggleSortAlpha()
}
</script>

<template>
    <Button @click="toggleSortAlpha" :active-value="sortAlpha" class="btn-sm">
        <i class="bi bi-sort-alpha-down"/>
    </Button>
</template>